<form [formGroup]="formGroup!" class="register" data-testid="profile-step-container">

  <app-modal-option-panel>
    <div class="modal-option-panel__stack">
      <app-avatar #avatarComponent (avatarProcessing)="onAvatarProcessing($event)" data-testid="profile-step-avatar"></app-avatar>

      <div class="input-el flex-column">
        <label class="required" for="profile-step-firstname">{{ languageService.languageJSON.AccountDialog_FirstName }}</label>
        <div>
          <input id="profile-step-firstname" name="firstname" required formControlName="registerFirstName" type="text" maxlength="64" data-testid="profile-step-firstname-input">
        </div>
        @if (registerFirstName.invalid && registerFirstName.touched) {
          <h6 class="invalid">{{ languageService.languageJSON.AccountDialog_FirstName_Error }}</h6>
        }
      </div>

      <div class="input-el flex-column">
        <label class="required" for="profile-step-lastname">{{ languageService.languageJSON.AccountDialog_LastName }}</label>
        <div>
          <input id="profile-step-lastname" name="lastname" required formControlName="registerLastName" type="text" maxlength="64" data-testid="profile-step-lastname-input">
        </div>
        @if (registerLastName.invalid && registerLastName.touched) {
          <h6 class="invalid">{{ languageService.languageJSON.AccountDialog_LastName_Error }}</h6>
        }
      </div>

      <div class="input-el flex-column">
        <label for="profile-step-country">{{ languageService.languageJSON.AccountDialog_Country }}</label>
        <mat-form-field class="modal-select-field">
          @if (countryList) {
            <mat-select disableRipple id="profile-step-country"
              [placeholder]="languageService.languageJSON.AccountDialog_Country_Select"
              formControlName="registerCountry" class="brand-mat-select"
              data-testid="profile-step-country-select">
              <mat-option value="" data-testid="profile-step-country-option-none">{{ languageService.languageJSON.AccountDialog_PreferNotToTell }}</mat-option>
              @for (countryEl of countryList; track countryEl) {
                <mat-option [value]="countryEl.code" [attr.data-testid]="'profile-step-country-option-' + $index">{{countryEl.name}}</mat-option>
              }
            </mat-select>
          }
        </mat-form-field>
        @if (registerCountry.invalid && registerCountry.touched) {
          <h6 class="invalid">{{ languageService.languageJSON.AccountDialog_Country_Select }}</h6>
        }
      </div>

      <div class="input-el flex-column">
        <label for="profile-step-phone">{{ languageService.languageJSON.AccountDialog_Phone }}</label>
        <input id="profile-step-phone" formControlName="registerPhone" type="tel" name="telephone" inputmode="numeric"
          maxlength="50" data-testid="profile-step-phone-input" />
        @if (registerPhone.value.length>0 && registerPhone.invalid && registerPhone.touched) {
          <h6 class="invalid">{{ languageService.languageJSON.AccountDialog_Phone_Error }}</h6>
        }
      </div>

      <div class="input-el flex-column">
        @if (backendErrorMsg && !isEditMode) {
          <h6 class="invalid registration-error">
            {{ languageService.languageJSON.AccountDialog_RegistrationError }}
            {{ backendErrorMsg }}
          </h6>
        }
        @if (backendErrorMsg && isEditMode) {
          <h6 class="invalid registration-error">{{ backendErrorMsg }}</h6>
        }
      </div>
    </div>
  </app-modal-option-panel>

  @if (isEditMode) {
    <app-modal-option-panel>
      <div class="input-el checkbox">
        <mat-checkbox formControlName="registerNewsletter" data-testid="profile-step-newsletter-checkbox">
          {{ languageService.languageJSON.AccountDialog_SubscribeNewsletter }}
        </mat-checkbox>
      </div>

      <div class="profile-actions">
        @if (!accountService.social) {
          <button type="button" class="ev-plain-button profile-action-link" (click)="changePassword.emit()" data-testid="profile-step-change-password-link">{{ languageService.languageJSON.AccountDialog_ChangePassword }}</button>
        }
        <button type="button" class="ev-plain-button profile-action-link" (click)="deleteProfile.emit()" data-testid="profile-step-delete-account-link">{{ languageService.languageJSON.AccountDialog_DeleteAccount }}</button>
      </div>
      <button type="button" class="ev-plain-button profile-actions" (click)="downloadUserData.emit()" data-testid="profile-step-download-data-link">
        <span class="profile-action-link">{{ languageService.languageJSON.AccountDialog_DownloadUserData }}</span>
      </button>
    </app-modal-option-panel>
  }
</form>
